export default "__VITE_ASSET__924efa64__"